export const basicPage = {
    secureAlias: []
};